export const basicPage = {
    secureAlias: []
};